import { render, staticRenderFns } from "./RIDC.vue?vue&type=template&id=9a172280&scoped=true&"
import script from "./RIDC.vue?vue&type=script&lang=ts&"
export * from "./RIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a172280",
  null
  
)

export default component.exports